import { bytesToNDigits } from 'lib/bytes';
import React, { useMemo } from 'react';
import { useButtons } from 'reactApp/components/UploadBigFileDialog/hooks/useButtons';
import { useTariff } from 'reactApp/components/UploadBigFileDialog/hooks/useTariff';

import { Content, EShowTariffType, IBigFileModalContent } from '../UploadBigFileDialog.types';

export const useContent = ({ subscription, numberOfFiles, file, files, callbacks }: IBigFileModalContent): Content => {
    const { uploadLimit, showTariffType, showProTariff } = subscription;

    const getAnnotation = () => {
        const limit = useMemo(() => bytesToNDigits(uploadLimit, 3), [uploadLimit]);
        let annotation = <>Файл слишком тяжёлый. Чтобы загружать файлы больше {limit.value}, подключите один из платных тарифов.</>;

        if (showTariffType === EShowTariffType.PRO) {
            annotation = (
                <>
                    {files ? 'Файлы слишком тяжёлые' : 'Файл слишком тяжёлый'} для вашего тарифа. Чтобы загружать файлы больше{' '}
                    {showProTariff ? '32 ГБ' : limit.value}, переходите на PRO!
                </>
            );
        }

        return annotation;
    };

    const tariffActions = useTariff(callbacks);
    const buttonActions = useButtons({ subscription, numberOfFiles, files, callbacks });

    return {
        header: files ? 'Невозможно загрузить файлы' : `Невозможно загрузить файл ${file?.name || ''}`,
        annotation: getAnnotation(),
        actions: showProTariff ? tariffActions : buttonActions,
    };
};
